// extracted by mini-css-extract-plugin
export default {"textCard":"cardMenu_textCard__VJZKv"};